import React from 'react';

import {
  FormProviderNewAddress,
  Paragraph,
  SubtitleSecondary,
} from '@components/index';

import { Container, Group } from './styles';

interface IProps {
  myStep: number;
  currentStep: number;
  changeStep(newStep: number, willChangeHistory?: boolean): void;
}

const StepAddress: React.FC<IProps> = ({ currentStep, changeStep }) => {
  return (
    <Container>
      <SubtitleSecondary textAlign="start" nameColor="black">
        Endereço
      </SubtitleSecondary>
      <Paragraph
        textAlign="start"
        nameColor="black"
        opacity={0.5}
        fontWeight={500}
      >
        Cadastre uma ou mais bases de operações
      </Paragraph>
      <Group>
        <FormProviderNewAddress
          forNewProviderAddress={{
            advanceStep: () => {
              changeStep(currentStep + 1);
            },
          }}
        />
      </Group>
    </Container>
  );
};

export default StepAddress;
